import React, { PureComponent } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import Lightbox from 'react-image-lightbox';

import { Block } from 'common/components/styleguide/grid/Block';
import Image from 'common/components/_base/Image';
import Carousel from 'common/components/styleguide/Carousel';
import { withCssUnit } from 'common/components/styleguide/utils/index';

const DEFAULT_GALLERY_MAIN_IMAGE_BACKGROUND = 'transparent';
const DEFAULT_GALLERY_MAIN_IMAGE_PADDING = '40px 0';

const DEFAULT_GALLERY_THUMBNAIL_BACKGROUND = 'transparent';

const DEFAULT_GALLERY_WIDTH_XS = '100%';
const DEFAULT_GALLERY_WIDTH_MD = '80%';

const S = {};
S.MainImageLink = styled.a`
  position: relative;
  display: block;
  text-decoration: none;
  overflow: hidden;
  flex: 1 0 0;
  background: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'mainImage.background',
      _.get(
        theme,
        'gallery.mainImage.background',
        DEFAULT_GALLERY_MAIN_IMAGE_BACKGROUND
      )
    )};
  border-color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'mainImage.border.color',
      _.get(theme, 'gallery.mainImage.border.color')
    )};
  border-style: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'mainImage.border.style',
      _.get(theme, 'gallery.mainImage.border.style')
    )};
  border-width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'mainImage.border.width',
      _.get(theme, 'gallery.mainImage.border.width')
    )};
  padding: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'mainImage.padding',
      _.get(
        theme,
        'gallery.mainImage.padding',
        DEFAULT_GALLERY_MAIN_IMAGE_PADDING
      )
    )};
  margin: ${({ theme, customStyle, gotThumbs }) =>
    gotThumbs
      ? _.get(
          customStyle,
          'mainImage.margin',
          _.get(theme, 'gallery.mainImage.margin')
        )
      : 0};
`;

S.MainImage = styled(Image)`
  display: block;
  height: auto;
  min-width: 100%;
  width: auto;
`;

S.ThumbnailLink = styled.a`
  display: flex !important;
  justify-content: center;
  width: auto !important;
  overflow: hidden;
  background: transparent;
  margin: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.margin',
      _.get(theme, 'gallery.thumbnail.margin')
    )};
  padding: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.padding',
      _.get(theme, 'gallery.thumbnail.padding')
    )};
  border-color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.borderColor',
      _.get(theme, 'gallery.thumbnail.border.color')
    )};
  border-style: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.borderStyle',
      _.get(theme, 'gallery.thumbnail.border.style')
    )};
  border-width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.borderWidth',
      _.get(theme, 'gallery.thumbnail.border.width')
    )};
  border-radius: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.borderRadius',
      _.get(theme, 'gallery.thumbnail.border.radius')
    )};
`;

S.ThumbnailImage = styled(Image)`
  display: block;
  height: auto;
  max-width: 100%;
  width: auto;
  max-width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'thumbnail.maxWidth',
      _.get(theme, 'gallery.thumbnail.maxWidth', '100%')
    )};
`;

S.GalleryWrapper = styled.section`
  width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'slider.width.xs',
      _.get(theme, 'gallery.width.xs', DEFAULT_GALLERY_WIDTH_XS)
    )};
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    width: ${({ theme, customStyle }) =>
      _.get(
        customStyle,
        'slider.width.md',
        _.get(theme, 'gallery.width.md', DEFAULT_GALLERY_WIDTH_MD)
      )};
  }
`;

S.MainImageLinkOuter = styled.div`
  position: relative;
`;

class GalleryVariant1 extends PureComponent {
  state = {
    lightboxIsOpen: false
  };
  openLightbox = (index, event) => {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  };
  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
  };
  handleClickImage = () => {
    if (this.props.currentImage === this.props.images.length - 1) return;
    this.gotoNext();
  };
  renderGallery(images = [], customStyle) {
    const gallery = _.map(images, (obj, i) => {
      const index = i + 1;
      return (
        <S.ThumbnailLink
          href={obj.src}
          key={'gallery-thumbnail' + index}
          onClick={e => this.openLightbox(index, e)}
        >
          <S.ThumbnailImage
            src={obj.pathThumb}
            title={obj.caption}
            alt={obj.caption}
            lazyload={false}
            customStyle={customStyle}
            updateTime={obj.updateTime}
          />
        </S.ThumbnailLink>
      );
    });
    if (gallery.length > 0) {
      return (
          <Carousel
            arrowSize={'small'}
            settings={{
              autoplay: false,
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: false,
              responsive: [
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }
              ]
            }}
          >
            {gallery}
          </Carousel>
      );
    }
    return null;
  }
  render() {
    const {
      image,
      galleryImages,
      currentImage,
      gotoPrevious,
      gotoNext,
      gotoImage,
      customStyle,
      labels,
      otherImageContent,
      backdropClosesModal,
      showThumbnails
    } = this.props;
    const allImages = _.concat(image, galleryImages);
    const updateTimeTimestamp = image.updateTime ? '?v=' + Date.parse(image.updateTime) : '';
    return (
      <Block
        backgroundColor="transparent"
        marginConfig={{ bottom:true }}
        paddingConfig={{}}
      >
        <S.MainImageLinkOuter>
          <S.MainImageLink
            href={image.src + updateTimeTimestamp}
            onClick={e => this.openLightbox(0, e)}
            customStyle={customStyle}
            gotThumbs={!_.isEmpty(galleryImages)}
          >
            <S.MainImage
              src={image.pathThumb}
              title={image.caption}
              alt={image.caption}
              updateTime={image.updateTime}
            />
          </S.MainImageLink>
          {labels}
          {otherImageContent}
        </S.MainImageLinkOuter>
        {showThumbnails && !_.isEmpty(galleryImages) ? (
          <S.GalleryWrapper customStyle={customStyle}>
            {this.renderGallery(galleryImages, customStyle)}
          </S.GalleryWrapper>
        ) : (
          ''
        )}
        {this.state.lightboxIsOpen && (
          <Lightbox
            mainSrc={allImages[currentImage].src}
            nextSrc={allImages[(currentImage + 1) % allImages.length].src}
            prevSrc={
              allImages[
                (currentImage + allImages.length - 1) % allImages.length
              ].src
            }
            onCloseRequest={this.closeLightbox}
            onMovePrevRequest={() =>
              gotoImage(
                (currentImage + allImages.length - 1) % allImages.length
              )
            }
            onMoveNextRequest={() =>
              gotoImage((currentImage + 1) % allImages.length)
            }
          />
        )}
      </Block>
    );
  }
}

export default GalleryVariant1;
